import {Component, inject, input, InputSignal, signal, WritableSignal} from '@angular/core';
import {Avatar} from "primeng/avatar";
import {Menu} from "primeng/menu";
import {Ripple} from "primeng/ripple";
import {Observable} from 'rxjs';
import {ThemeService} from '../../../services/theme.service';
import {User} from '../../../interfaces/user';
import {UserService} from '../../../services/user.service';
import {MenuItem, MessageService} from 'primeng/api';
import {AuthService} from '../../../services/auth.service';
import { LayoutService } from '../../../services/layout.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-navbar',
  imports: [
    Avatar,
    Menu,
    Ripple,
    ButtonModule
  ],
  templateUrl: './navbar.html',
  styleUrl: './navbar.css'
})
export class Navbar {

  private readonly _userService: UserService = inject(UserService);
  private readonly _messageService: MessageService = inject(MessageService);
  private readonly _themeService: ThemeService = inject(ThemeService);
  private readonly _authService: AuthService = inject(AuthService);
    private readonly _layoutService: LayoutService = inject(LayoutService);

  public title: InputSignal<string> = input<string>('');

  public isDarkMode: WritableSignal<Observable<boolean>> = signal<Observable<boolean>>(this._themeService.isDarkMode$());

  public user: WritableSignal<User|null> = signal<User|null>(null);

  public avatarMenuItems: MenuItem[] = [
    // {
    //   label: 'Perfil',
    //   icon: 'fa-regular fa-user',
    //   command: () => console.log('user')
    // },
    {
      label: 'Sair',
      icon: 'fa-solid fa-right-from-bracket',
      command: () => this._authService.logout()
    }
  ];

  public ngOnInit() {
    this._getUser();
  }

  public toggleDarkMode(): void {
    this._themeService.toggleDarkMode();
  }

  private _getUser(): void {
    this._userService.me()
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.user.set(response.data);
          }
        },
      })
  }

  public toggleMenuDrawer(): void {
    this._layoutService.toggleMenuDrawer();
  }

  public onAvatarMenuItemClick(menu: Menu, item: MenuItem, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    menu.hide();

    queueMicrotask(() => item.command?.({ originalEvent: event, item }));
  }
}
